"use strict";

Fotobook.holidays.marks = {

    getAll() {
        return $("symbol.holiday-mark").map(function () {
            return $.extend({}, this.dataset);
        });
    },
};
